'use client';

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useNetworkStatus } from '@/lib/use-network-status';

export function NetworkStatusBanner() {
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center px-4 py-2 bg-amber-400 text-amber-950 shadow-sm animate-in slide-in-from-top duration-300">
      <AlertTriangle className="w-4 h-4 mr-2" />
      <span className="text-sm font-medium">
        You are currently offline. Some features may be unavailable.
      </span>
    </div>
  );
}
